module.exports = __webpack_public_path__ + "static/media/cathedralinside.a07ddb32.png";